/*  ========================================================================
    # Pages - Home
    ========================================================================  */

// Dependencies
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

// Components
import Footer from '@components/Footer';

// Sections
import Intro from '@sections/Intro';
import WhatIsIt from '@sections/WhatIsIt';
import HowItWorks from '@sections/HowItWorks';
import SubmittedIdeas from '@sections/SubmittedIdeas';
import WhoIsRaiffeisen from '@sections/WhoIsRaiffeisen';
import Checklist from '@sections/Checklist';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Raiffeisen-Förderpreis 2025 – Deine Region. Dein Projekt. Deine Zukunft.</title>
      </Helmet>

      <motion.main
        className='p-home'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Intro />
        <WhatIsIt />
        <HowItWorks />
        <SubmittedIdeas />
        <WhoIsRaiffeisen />
        <Checklist />
        <Footer />
      </motion.main>
    </>
  );
};

export default Home;
